/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
// material
import { Container } from '@material-ui/core';

// eslint-disable-next-line import/no-unresolved
import ColumnMapView from 'src/components/_dashboard/colum-map/ColumnMapView';

// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
//  redux
import { useDispatch, useSelector } from '../../redux/store';
import { getClientList, getProjectListByClient, resetProjectListByClient } from '../../redux/slices/client';
import { resetCategoryListByProject, getCategoryListByProject } from '../../redux/slices/filecategory';
import { getMasterFileData } from '../../redux/slices/masterfile';
import { getColumnMapList } from '../../redux/slices/columnmap';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// ----------------------------------------------------------------------

export default function ColumnMap() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { CopyFromColumnList } = useSelector((state) => state.columnmap);
  const [id, setId] = useState();
  const [currentData, setCurrentData] = useState({});

  useEffect(() => {
    dispatch(getClientList(true));
    dispatch(getMasterFileData());
    dispatch(getColumnMapList());
    dispatch(resetProjectListByClient());
    dispatch(resetCategoryListByProject());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      const currentList = CopyFromColumnList.find((map) => map.id === id);
      dispatch(getProjectListByClient(currentList?.client?.id));
      dispatch(getCategoryListByProject(currentList?.project?.id));
      setCurrentData(currentList);
    }
  }, [id]);

  return (
    <Page title="Columnmap | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading="Column Mapping for Import"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Column Map', href: PATH_DASHBOARD.general.columnmap }
          ]}
        />
        <ColumnMapView id={id} setId={setId} COLUMN_LIST={CopyFromColumnList} currentData={currentData} />
      </Container>
    </Page>
  );
}
